"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconPixelSize = exports.ICON_SIZES = void 0;
const ICON_SIZES = exports.ICON_SIZES = ['xl', 'xl-minus', 'lg-plus', 'lg', 'lg-minus', 'md-plus', 'md', 'md-minus', 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'];
const ICON_PIXEL_SIZES = {
  xl: 48,
  'xl-minus': 42,
  'lg-plus': 36,
  lg: 32,
  'lg-minus': 28,
  'md-plus': 26,
  md: 24,
  'md-minus': 20,
  'sm-plus': 18,
  sm: 16,
  'sm-minus': 14,
  'xs-plus': 12,
  xs: 11
};
const getIconPixelSize = size => ICON_PIXEL_SIZES[size];
exports.getIconPixelSize = getIconPixelSize;